/**
 * Order cooking times by the number of minutes ASC
 *
 * @param cookingTimes[]
 * @returns {*}
 */
export default function orderCookingTimes(cookingTimes) {
    // Define a helper function to extract the amount of minutes from the `name` property
    const extractMinutes = (name) => {
        const pattern = /(\d+)(-\d+)? mins?/;
        const matches = name.match(pattern);
        if (matches) {
            return Number(matches[1]);
        }
        return 0;
    };

    // Sort the array based on the extracted amount of minutes
    return cookingTimes?.sort((a, b) => (extractMinutes(b.name) - extractMinutes(a.name)));
}
